// Ambient music by area (Matt, 2026-10-14: "Create ambient background music for different areas"). Tracks are
// our own Suno renders in client/public/music/ (tracks.json). Two <audio> elements crossfade when the area
// changes; nothing plays until the first tap or key (browser autoplay rules); M mutes, and that is remembered.
export class AreaMusic {
  tracks: Record<string, { file: string }> = {};
  a = [new Audio(), new Audio()];
  cur = 0; now = ''; want = ''; unlocked = false; muted = false; vol = 0.32;
  /** R3-026: first play downloaded about 4 MB of music before you could move (the title theme twice, then the Tavern's).
   *  The area tracks wait until you have control (main.ts release()); the title theme is fetched once */
  held = true;
  release() { if (!this.held) return; this.held = false; const w = this.want; if (w && w !== this.now) this.area(w); }
  fadeT: number | undefined;
  constructor() {
    try { this.muted = localStorage.getItem('dm_mute') === '1'; } catch { /* private mode */ }
    for (const el of this.a) { el.loop = true; el.preload = 'none'; el.volume = 0; }   // nothing is fetched until a track plays
    fetch('music/tracks.json').then(r => r.ok ? r.json() : {}).then(j => {
      for (const [k, v] of Object.entries(j as Record<string, any>)) if (v && (v.file || typeof v === 'string')) this.tracks[k] = { file: typeof v === 'string' ? v : v.file };
      if (this.want) { const w = this.want; this.want = ''; this.area(w); }
    }).catch(() => {});
  }
  unlock() { if (this.unlocked) return; this.unlocked = true; const w = this.want || this.now; this.now = ''; if (w) this.area(w); }   // (once: a second unlock re-sourced the title on the other element)
  toggle() {
    this.muted = !this.muted;
    try { localStorage.setItem('dm_mute', this.muted ? '1' : '0'); } catch { /* */ }
    for (const el of this.a) el.volume = this.muted ? 0 : (el === this.a[this.cur] ? this.vol : 0);
  }
  /** OPTIONS: the music volume (the M key still mutes everything) */
  setVol(v: number) { this.vol = v; if (!this.muted) this.a[this.cur].volume = v; }
  area(name: string) {
    this.want = name;
    if (name === this.now || !this.unlocked || (this.held && name !== 'title')) return;
    const t = this.tracks[name] ?? this.tracks[name.replace(/_(day|night)$/, '_day')];
    if (!t) return;
    this.now = name;
    const next = 1 - this.cur, inn = this.a[next], out = this.a[this.cur];
    const src = 'music/' + t.file.replace(/^.*\//, '');
    if (!inn.src.endsWith(src)) { inn.src = src; inn.currentTime = 0; }
    inn.volume = 0; inn.play().catch(() => {});
    this.cur = next;
    clearInterval(this.fadeT);
    let k = 0;
    this.fadeT = window.setInterval(() => {
      k = Math.min(1, k + 0.05);
      inn.volume = this.muted ? 0 : this.vol * k;
      out.volume = this.muted ? 0 : this.vol * (1 - k);
      if (k >= 1) { clearInterval(this.fadeT); out.pause(); }
    }, 100);
  }
}

/** one player for the whole page: the title theme on the title screen, then the areas */
export const MUSIC = new AreaMusic();
